import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import type { CountryProps } from "forms/fields/ContactData/types";
import FormItem from "forms/fields/FormItem";
import parseDictionary from "forms/helpers/parseDictionary";
import { predefinedFields } from "types/predefinedFields";
import { Select } from "ui/Select/Select";
import { FormField } from "uiShadcn/form";
export default function Country(t0) {
  const $ = _c(11);
  const {
    control,
    data
  } = t0;
  const {
    formatMessage
  } = useIntl();
  let t1;
  if ($[0] !== data) {
    t1 = parseDictionary({
      enumNames: data?.["x-enumNames"] ?? [],
      enumValues: data?.enum ?? []
    });
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = Object.entries(options).map(_temp);
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const dictionary = t2;
  let t3;
  if ($[4] !== data.type || $[5] !== dictionary || $[6] !== formatMessage) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem label={formatMessage({
        id: "country"
      })} required={data.type === "integer"}><Select ref={field.ref} dataTestId={`Select-${field.name}`} defaultValue={field.value} onValueChange={field.onChange} required={data.type === "integer"} options={dictionary} placeholder={formatMessage({
          id: "select"
        })} /></FormItem>;
    };
    $[4] = data.type;
    $[5] = dictionary;
    $[6] = formatMessage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== control || $[9] !== t3) {
    t4 = <FormField control={control} name={predefinedFields.country} render={t3} />;
    $[8] = control;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(t0) {
  const [value, label] = t0;
  return {
    key: value,
    value: label
  };
}